/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/*
 * Using this json only for 18F brand.
 */
const data = {
    header_data: {
        title: 'Appropriate Funeral Flowers & Sympathy Gifts',
        subText: '<p style=font-size:14px color:#666666 font-family:"Roboto", sans-serif> Helping someone deal with the loss of a loved one is never easy. When it’s hard to find the words to say, sending <a style=color:#000000 font-size=14px href="/allfuneralarrangements"> funeral flowers </a> for the service, or sympathy gifts to the home, are a common way to express your deepest condolences. Below are helpful funeral etiquette tips for you to be able to lend your support during a difficult time, along with helpful recommendations based on your relationship with the deceased. If you’re in search for <a style=color:#000000 font-size=14px href="/Sympathy-Sympathy-Etiquette"> sympathy etiquette for different religions</a>, we have specific content about that, too.<p>',
        casketFlowers: [
            {
                heading: 'Etiquette for Sending Funeral Flowers & Sympathy Gifts Based on Relationship',
                image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/2015/sympathy/sympathy-funeral-standing-wreaths.jpg?height=138&width=265',
            },
        ],
        standingFlowers: [
            {
                heading: 'Immediate Family',
                image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/91287lc.jpg?height=256&width=234',
            },
        ],

        funeralService: [
            {
                heading: 'Sending Flowers to the Funeral Service',
                content: 'Professional colleagues will generally send a group gift. An appropriate floral arrangement for the service might be a standing spray, standing basket or fireside basket.',
            },
        ],
        friends: [
            {
                heading: 'Friends',
                image: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/146509c.jpg?height=256&width=234',
            },
        ],
        funeralHome: [
            {
                heading: 'Sending Flowers to the Funeral Home',
                sentenceOne: 'Of course there are always different levels of friendship, from good acquaintances to best friends. Depending on your closeness, it may alter the sympathy gift you choose for those in mourning. Chipping in with a group of friends, also will change your decision.',
                sentenceTwo: 'For close friends, and large friend groups, standing sprays or abundant flower baskets to be placed on display at the funeral service, are always a safe and thoughtful choice. For looser relationships, sending a modest funeral flower arrangement for the service is a very nice gesture.',
            },
        ],
        sympathyGifts: [
            {
                heading: 'Sending Sympathy Gifts to the Home',
                content: 'If you are unable to attend the services, it is generally appropriate to send your condolences to the grieving family\'s home.',
                contentNext: '<p style=font-size:14px color:#666666 font-family:"Roboto", sans-serif>Traditional choices for a sympathy gift to the home include an elegant vase of flowers, basket arrangements or <a style=color:#000000 font-size=14px href="/sympathyplants">sympathy plants.</a> Sympathy gift baskets have also become a popular and thoughtful gift to send to the home. Whether looking for savory options, or sweet options, there are many <a style=color:#000000 font-size=14px href="/sympathygiftbasketsfoodgifts">gourmet sympathy gift  baskets</a>  of comfort food to choose from, with everything from meat and cheese to cookies and chocolate.</p>',

            },
        ],
        sendingFlowers: [
            {
                heading: 'Sending Flowers and Gifts to the Home',
                content: '<p style=font-size:14px color:#666666 font-family:"Roboto", sans-serif>In most cases, a note or card to the family is appropriate and sufficient to express your sympathy to the family of a deceased work colleague. If you worked closely together, you might send a <a style=color:#000000 font-size=14px href="/sympathyflowers">condolence flower arrangement in a vase</a>, a dish garden or blooming plant. Fruit, food or gourmet baskets are also appropriate and would be appreciated.</p> ',
                contentNext: '<p style=font-size:14px color:#666666 font-family:"Roboto", sans-serif>If you\'re still unsure of what to get for a family in mourning, one of our skilled and compassionate Sympathy Advisors, is available to help. You can reach the Sympathy Customer Service line toll free at 1-866-538-2259, or online through live chat assistance at <a style=color:#000000 font-size=14px href="/">www.1800flowers.com</a></p> ',
            },
        ],
    },
};
export default data;
